// extracted by mini-css-extract-plugin
export default {"danger":"button_danger__0vI43","primary":"button_primary__ORBqv","small":"button_small__h5j9d","medium":"button_medium__d7FwM","button":"button_button__zpxkc"};